import { render, staticRenderFns } from "./Policy-area.vue?vue&type=template&id=505c8179"
import script from "./Policy-area.js?vue&type=script&lang=js&external"
export * from "./Policy-area.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports